import React from 'react';
import PropTypes from 'prop-types';
import './uploadFilesProgress.scss';

class UploadFilesProgress extends React.Component {

  componentWillMount = () => {
    this.startUpload();
  };

  startUpload = () => {
    const { additionalInformation, acceptedFiles, url, queryString, headers, filesActions: { uploadFiles } } = this.props;

    uploadFiles({
      files: acceptedFiles,
      additionalInformation,
      url,
      queryString,
      headers
    });
  };

  render() {
    const { loaded, total, message } = this.props;
    return (
      <div className="file-progress__container">
        <p>{ message }</p>
        <progress
          id="upload-progress"
          max={ total }
          value={ loaded }
        />
      </div>
    );
  }
}

UploadFilesProgress.propTypes = {
  loaded: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  acceptedFiles: PropTypes.arrayOf(PropTypes.object).isRequired,
  additionalInformation: PropTypes.object,
  headers: PropTypes.arrayOf(PropTypes.array),
  message: PropTypes.string,
  queryString: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  onComplete: PropTypes.func,
  filesActions: PropTypes.shape({
    uploadFiles: PropTypes.func
  }).isRequired
};

UploadFilesProgress.defaultProps = {
  message: '',
  additionalInformation: {},
  headers: [],
  queryString: '',
  onComplete: () => {}
};

export default UploadFilesProgress;



// WEBPACK FOOTER //
// ./src/shared/components/fileDrop/c/uploadFilesProgress/UploadFilesProgress.js